@if (!navigatieVoorkeurService.nieuweNavigatie()) {
	<div class="menu">
		<app-user-tab-menu></app-user-tab-menu>
	</div>
}
<div class="content">
	<div class="uitleg">
		Hier kun je de schooleigen norm van het dashboard Basisvaardigheden instellen. Hierdoor kun je de resultaten van jouw school vergelijken met
		de gestelde doelen.
		<br />
		De ingestelde normen worden direct toegepast en zichtbaar op het dashboard Basisvaardigheden.
	</div>
	<div class="toolbar">
		@if (vestigingOpties$ | async; as opties) {
			<div class="selector vestiging">
				<span>Vestiging</span>
				<app-multi-select-dropdown
					[allOptions]="opties"
					(valueChange)="selecteerVestigingen($event)"
					[enabled]="!dirty()"
				></app-multi-select-dropdown>
			</div>
		}
		<div class="selector schooljaar">
			<span>Schooljaar</span>
			<app-multi-select-dropdown
				[allOptions]="schooljaarOpties"
				[value]="schooljaren()"
				(valueChange)="schooljaren.set($event)"
				[enabled]="!dirty()"
			></app-multi-select-dropdown>
		</div>
		<div class="buttons">
			<app-button buttonType="secondary" [enabled]="dirty()" (clickit)="revert()">Annuleren</app-button>
			<app-button [enabled]="dirty()" (clickit)="trySave()">Opslaan</app-button>
		</div>
	</div>
	@if (overwriteWarning()) {
		<div class="warning-message">
			<app-icon name="warning" color="warning-1"></app-icon>
			<div>{{ overwriteWarning() }}</div>
		</div>
	}
	@if (showErrors() && !correct()) {
		<div class="error-message">
			<app-icon name="error" color="error-1"></app-icon>
			<div>De percentages tellen niet op tot 100%. Controleer de ingevoerde waarden en probeer het opnieuw.</div>
		</div>
	}
	<div class="tabel">
		@if (table()) {
			<div class="header row">
				<div class="leerfase">Leerfase</div>
				@for (niveau of niveaus(); track niveau) {
					<div [class]="'niv' + $index">{{ niveau }}</div>
				}
				<div class="accent">Verdeeld</div>
				<div class="accent">Over</div>
			</div>
			@for (row of table()!.rows; track row.leerfase; let rowIx = $index) {
				<div class="row" [class.error]="showErrors() && incorrectRows().includes(rowIx)">
					<div class="leerfase">{{ row.leerfase }}</div>
					@for (doel of row.doelen; track colIx; let colIx = $index) {
						@let valid = isValid(doel);
						<div class="input-wrapper" [class.invalid]="!valid">
							<input
								type="text"
								[attr.id]="getInputId(rowIx, colIx)"
								maxlength="3"
								[value]="fractionToText(doel)"
								(input)="updateTable(rowIx, colIx)"
								(keydown)="onKeydown(rowIx, colIx, $event)"
								[appTooltip]="resolveDoelTooltip(doel)"
								tooltipClass="error"
								tooltipPosition="right"
							/>
							@if (!valid) {
								<app-icon class="invalid-icon" name="sluiten" color="error-1" size="smallest"></app-icon>
							}
						</div>
					}
					<div class="accent">{{ fractionToText(totals()[rowIx]) }} %</div>
					<div class="accent">{{ fractionToText(1 - totals()[rowIx]) }} %</div>
				</div>
			}
		}
	</div>
</div>
